import UrqlClient from '@/app/graphql/client';
import { getSdk } from './sdk.statement';

if (!import.meta.env.VITE_APP_ENDPOINT) new Error('Нет переменной VITE_APP_ENDPOINT');

const client = new UrqlClient(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/ob-statement-service/graphql`);
const sdkStatementService = getSdk(client);

export * from './sdk.statement';
export default sdkStatementService;
